<template>
  <div class="page__title">
    <img
      src="@/assets/icons/api_key.svg"
      class="mr-2"
      style="max-height: 10%"
    />
    <h1>{{ $t(`${namespace}.pageTitle`) }}</h1>
  </div>
</template>
<script>
export default {
  name: 'Title',
  data () {
    return {
      namespace: 'Views.TokenRequestPage'
    }
  }
}
</script>
<style lang="scss" scoped>
.page__title {
    display: inline-flex;
    padding: 24px 24px 0;
    width: 100%;

    h1 {
        font-size: 18px;
    }
}
</style>
